import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import "react-datepicker/dist/react-datepicker.css";
import Input from "../UniversalComponents/InputComponent";
// import { Input } from "@mui/material";
import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import VendorHeaderHoc from "./VendorHeaderHoc";

const PurchaseOrder = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [InputValue, setInputValue] = useState("");
  const [shippingAddressValue, setshippingAddressValue] = useState("");
  const [purchaseOrderDate, setPurchaseOrderDate] = useState("");

  const placeholder = "DD-MM-YYYY";
  const displayFormat = "dd-MM-yyyy";

  const handlePurchaseOrderDate = (date) => {
    setPurchaseOrderDate(date);
  };

  const [formData, setFormData] = useState({
    nameField: "", // Rename to avoid conflict with global 'name'
    valueField: "",
  });

  const vendorOptions = [
    { label: "Vendor 1", value: "vendor1" },
    { label: "Vendor 2", value: "vendor2" },
  ];

  const termsOptions = [
    { label: "Term 1", value: "term1" },
    { label: "Term 2", value: "term2" },
  ];
  const handleButtonClickAddLines = () => {};

  const handleshippingAddressChange = (e) => {
    setshippingAddressValue(e.target.value);
  };
  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleSelectTermChange = (event) => {
    setSelectedTermValue(event.target.value);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleMailInputChange = (event) => {
    setInputValue(event.target.value);
  };
  // const DownAngelBracket = () => {
  //   return <span>{'<'}</span>;
  // };

  return (
    <div className="mx-10">
      <div className=" mt-3 flex gap-5 items-start w-[100%]">
        <div className=" border-[#DFE2E5] bg-white border rounded-md flex flex-wrap gap-3 p-2 w-[100%]">
          {/* First row */}

          <div className="w-[30%]  min-w-64">
            <label className="w-full text-14 text-434852 font-400 pb-1 ">Vendor</label>
            <div>
              <Select
                placeholder={"Choose a Vendor"}
                options={vendorOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>

          <div className="w-[30%] min-w-64 ">
            <div className="text-14 font-400">Email</div>
            <div>
              <Input
                name="emailInput"
                placeholder="Enter Email Address"
                label="Enter Email"
                value={InputValue}
                onChange={handleInputChange}
                style={{ width: "[100%]", height: ["35px"] }}
              />
            </div>
          </div>

          <div className="w-[30%] min-w-64">
            <div className="text-[#434852]">Purchase Order status</div>
            <div>
              <Select
                placeholder={"Choose a Terms"}
                options={vendorOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>

          {/* SECOND row */}

          <div className="w-[30%] min-w-64">
            <div className="text-14 font-400">Mailing Address</div>
            <div>
              <Input
                name="text"
                placeholder="abc@gmail.com"
                value={InputValue}
                onChange={handleMailInputChange}
                style={{ width: "100%", height: "35px" }}
              ></Input>
            </div>
          </div>

          <div className="w-[30%] min-w-64">
            <div className="text-[#434852]">Ship To</div>
            <div>
              <Select
                placeholder={"Choose a Vendor"}
                options={vendorOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>

          <div className="w-[30%]  min-w-64">
            {/* replace with date component */}
            <div className="text-[#434852]">Purchase Order Date</div>

            <div className="flex items-center bg-white border border-[#DFE2E5] datePicker_container rounded">
              <DatePicker
                selected={purchaseOrderDate}
                onChange={handlePurchaseOrderDate}
                placeholderText={placeholder}
                dateFormat={displayFormat}
                className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
              ></DatePicker>

              <div>
                <CalendarWithTimeIcon></CalendarWithTimeIcon>
              </div>
            </div>
          </div>

          {/* Third row */}
          <div className="w-[30%]  min-w-64">
            <div className="text-[#434852]">Shipping Address</div>
            <div>
              <Input
                name="text"
                placeholder="Enter Address"
                value={InputValue}
                onChange={handleshippingAddressChange}
                style={{ width: "100%", height: "35px" }} // Additional styling if needed
              ></Input>
            </div>
          </div>

          <div className="w-[30%]  min-w-64">
            <div className="text-[#434852]">Ship Via</div>
            <div>
              <Select
                placeholder={"Select Customer"}
                options={vendorOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>

          <div className="w-[30%]  min-w-64">
            <div className="text-[#434852]">Tags</div>
            <div>
              <Select
                placeholder={"Select Tags"}
                options={vendorOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>
        </div>

        <div className="border-[#DFE2E5] bg-white border rounded-md items-center px-8 py-14 w-[20%]">
          <div className="flex flex-col bg-[#0093C1] gap-1 p-4 items-center ">
            <span className="text-[#FFFFFF] text-16 font-400 text-nowrap">Available Amount</span>
            <span className="text-[#FFFFFF] text-30">$ 0.00</span>
          </div>
        </div>
      </div>

      <div className="  mt-4 rounded-md">
        <div className="flex items-center justify-start space-x-2 pb-[10px]">
          <label className="text-18 font-600 text-1D4469">Category Details</label>
          <DownAngelBracket className="h-[8px] text-1D4469 " />
        </div>
      </div>
      <div className=" border rounded 1px solid bg-FFFFFF w-full h-36"></div>

      <div className="  mt-4  flex  space-x-2 items-center">
        <label className="text-18 font-600 text-1D4469"> Item Details</label>

        <DownAngelBracket className="h-[8px] text-1D4469 " />
      </div>

      <div className=" border rounded 1px solid bg-FFFFFF w-full h-36">
        <div className="flex items-center justify-between mb-3 p-2  gap-x-2">
          <div className="text-14 font-500">
            <Button
              type="primary"
              onClick={handleButtonClickAddLines}
              style={{
                margin: "1px",
                padding: "3px",
                height: "35px",
              }}
            >
              ADD LINES
            </Button>
          </div>
        </div>
      </div>

      {/* {LAST SECTION} */}

      <div className="flex flex-col gap-y-4[15px]"></div>

      <div className="bg-FFFFFF border rounded 1px solid mt-5">
        <div className="w-[100%]  p-[20px]">
          <div className="flex items-center justify-between gap-[9px]  mb-6 w-full">
            <div className="w-full">
              <div className="text-14 font-400 text-434852 mb-1">Your message to vendor</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>

            <div className="w-full ">
              <div className="text-14 font-400 text-434852 mb-1">Memo</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>
            <div className="w-full ">
              <div className="space-x-2 flex justify-between items-center ">
                <div className="space-x-2">
                  <span className=" text-14 font-600">Attachments(0)</span>
                  <span className="text-14 font-400">Maximum Size 20 MB</span>
                </div>
              </div>
              <div className="h-[125px] border rounded text-12 font-400  ">
                <div className="flex flex-col items-center justify-center h-full w-full text-center">
                  <div className="text-AFAFAF">Drop files here or click to select from the device</div>
                  <div className="flex bg-F4F4F4  justify-between items-center p-3 m-2 border rounded">
                    <div className="text-[11px] font-500">Upload from this device</div>
                    <div>
                      <DownAngelBracket />
                    </div>
                  </div>
                </div>
                <div className="pt-2 text-12 font-400 text-009CBF">Show Existing</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" flex justify-start items-center gap-x-4 mt-8 ">
        <div className="text-12 font-400 text-009CBF">Privacy</div>
        <div className="text-12 font-400 text-009CBF">Print</div>
        <div className="text-12 font-400 text-009CBF">Make Recurring</div>
      </div>
      <div className=" flex justify-end  ">
        <div className=" flex justify items-end space-x-2">
          <div className="w-[284px] bg-[#D4EAEE] border-[#BEDADF] flex justify-between text-16 text-[#535252] items-center rounded-5px pb-3 mt-2">
            <span className="font-400">Total</span>
            <span className="font-600 ">$ 0.00</span>
          </div>
          <Button type="primary" style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          {/* <Button type="primary" style={{ color: "#535252" }}>
            SAVE
          </Button> */}
          <Button type="secondary" style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </div>
  );
};
export default LayoutHOC(VendorHeaderHoc(PurchaseOrder));
